/**
 *
 * @var {string} label
 *      Label of the permission
 *
 * @var {object} elab
 *      @var {string} header
 *
 *      @var {string} text
 *
 * @var {string} type
 *      0 = No Access, View Only, View & Edit
 *      1 = No Access, View Only
 *      2 = No Access, View & Edit
 */

export const PermissionTypes = [
  {
    module: "Tenant Module",
    moduleKey: "tenant",
    permissions: [
      {
        key: "general",
        label: "View",
        type: "0",
        elaboration: [
          {
            header: "View",
            text: "Allows user to view tenant page and download spreadsheets",
          },
        ],
      },
      {
        key: "create",
        label: "Create",
        type: "0",
        elaboration: [
          {
            header: "Create",
            text: "Allows user to create new tenant entries",
          },
        ],
      },
      {
        key: "update",
        label: "Update",
        type: "0",
        elaboration: [
          {
            header: "Update",
            text: "Allows user to update existing tenant entries",
          },
        ],
      },
      {
        key: "delete",
        label: "Delete",
        type: "2",
        elaboration: [
          {
            header: "Delete",
            text: "Allows user to delete tenant entries permanently",
          },
        ],
      },
    ],
  },
  {
    module: "Notification Module",
    moduleKey: "notifications",
    permissions: [
      {
        key: "general",
        label: "View",
        type: "2",
        elaboration: [
          {
            header: "View",
            text: "Allows user to view notification page and download spreadsheets",
          },
        ],
      },
      {
        key: "create",
        label: "Create",
        type: "2",
        elaboration: [
          {
            header: "Create",
            text: "Allows user to create new notification entries",
          },
        ],
      },
      {
        key: "update",
        label: "Update",
        type: "2",
        elaboration: [
          {
            header: "Update",
            text: "Allows user to update existing notification entries",
          },
        ],
      },
      {
        key: "delete",
        label: "Delete",
        type: "2",
        elaboration: [
          {
            header: "Delete",
            text: "Allows user to delete notification entries permanently",
          },
        ],
      },
    ],
  },
  {
    module: "User Module",
    moduleKey: "staff",
    permissions: [
      {
        key: "general",
        label: "View",
        type: "2",
        elaboration: [
          {
            header: "View",
            text: "Allows user to view user page and download spreadsheets",
          },
        ],
      },
      {
        key: "create",
        label: "Create",
        type: "2",
        elaboration: [
          { header: "Create", text: "Allows user to create new user entries" },
        ],
      },
      {
        key: "update",
        label: "Update",
        type: "2",
        elaboration: [
          {
            header: "Update",
            text: "Allows user to update existing user entries",
          },
        ],
      },
      {
        key: "delete",
        label: "Delete",
        type: "2",
        elaboration: [
          {
            header: "Delete",
            text: "Allows user to delete user entries permanently",
          },
        ],
      },
    ],
  },
  {
    module: "Permissions Module",
    moduleKey: "permissions",
    permissions: [
      {
        key: "general",
        label: "View",
        type: "2",
        elaboration: [
          {
            header: "View",
            text: "Allows user to view permission group page and download spreadsheets",
          },
        ],
      },
      {
        key: "create",
        label: "Create",
        type: "2",
        elaboration: [
          {
            header: "Create",
            text: "Allows user to create new permission group entries",
          },
        ],
      },
      {
        key: "update",
        label: "Update",
        type: "2",
        elaboration: [
          {
            header: "Update",
            text: "Allows user to update existing permission group entries",
          },
        ],
      },
      {
        key: "delete",
        label: "Delete",
        type: "2",
        elaboration: [
          {
            header: "Delete",
            text: "Allows user to delete permission group entries permanently",
          },
        ],
      },
    ],
  },
  {
    module: "Appointment Module",
    moduleKey: "appointments",
    permissions: [
      {
        key: "general",
        label: "View",
        type: "2",
        elaboration: [
          {
            header: "View",
            text: "Allows user to view appointment page and download spreadsheets",
          },
        ],
      },
      {
        key: "create",
        label: "Create",
        type: "2",
        elaboration: [
          {
            header: "Create",
            text: "Allows user to create new appointment entries",
          },
        ],
      },
      {
        key: "update",
        label: "Update",
        type: "2",
        elaboration: [
          {
            header: "Update",
            text: "Allows user to update existing appointment entries",
          },
        ],
      },
      {
        key: "delete",
        label: "Delete",
        type: "2",
        elaboration: [
          {
            header: "Delete",
            text: "Allows user to delete appointment entries permanently",
          },
        ],
      },
    ],
  },
  {
    module: "Supporting Modules",
    moduleKey: "combined",
    permissions: [
      {
        key: "visitor",
        label: "Visitor",
        type: "2",
        elaboration: [
          {
            header: "View",
            text: "Allows user to view visitor page and download spreadsheets",
          },
        ],
      },
      {
        key: "contractor",
        label: "Contractor",
        type: "2",
        elaboration: [
          {
            header: "View",
            text: "Allows user to view contractor page and download spreadsheets",
          },
        ],
      },
      {
        key: "security",
        label: "Security",
        type: "2",
        elaboration: [
          {
            header: "View",
            text: "Allows user to view security page and download spreadsheets",
          },
        ],
      },
      {
        key: "reports",
        label: "Reports",
        type: "2",
        elaboration: [
          {
            header: "View",
            text: "Allows user to view and download general reports",
          },
        ],
      },
      {
        key: "history",
        label: "History",
        type: "2",
        elaboration: [
          {
            header: "View",
            text: "Allows user to view & search the history page",
          },
        ],
      },
    ],
  },
];

export const PermissionTypeOptions = {
  0: [
    { value: "0", label: "No Access" },
    { value: "1", label: "View Only" },
    { value: "2", label: "View & Edit" },
  ],
  1: [
    { value: "0", label: "No Access" },
    { value: "1", label: "View Only" },
  ],
  2: [
    { value: "0", label: "No Access" },
    { value: "2", label: "View & Edit" },
  ],
};
